import React from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CardDescriptionProps {
  text: string;
  className?: string;
}

const CardDescription: React.FC<CardDescriptionProps> = ({ text, className, ...rest }) => {
  const classes = useStyles();

  return (
    <Typography className={cx(classes.description, className)} {...rest}>
      {text}
    </Typography>
  );
};

export default CardDescription;
